export default "__VITE_ASSET__C66y0U8I__"